// extracted by mini-css-extract-plugin
module.exports =  {"buttons":"_93444fe79c--buttons--QbT_Z"};